module.exports = __webpack_public_path__ + "img/vip-crowd_cclub.2783a4fe.png";